export const createSyncStatusBannerStyles = (theme) => ({
	wrapper: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 24,
		paddingHorizontal: 16,
		alignItems: 'center',
	},
	banner: {
		backgroundColor: theme.mainBg3,
		borderRadius: 20,
		paddingVertical: 8,
		paddingHorizontal: 16,
		flexDirection: 'row',
		alignItems: 'center',
		elevation: 5,
		shadowColor: '#000',
		shadowOpacity: 0.1,
		shadowRadius: 6,
		shadowOffset: { width: 0, height: 2 },
	},
	bannerContent: {
		flexDirection: 'row',
		alignItems: 'center',
		flex: 1,
	},
	indicator: {
		width: 20,
		marginRight: 8,
		alignItems: 'center',
		justifyContent: 'center',
	},
	indicatorColor: {
		color: theme.text1,
	},
	indicatorWarning: {
		color: theme.danger1 || theme.semantic?.simple?.red || '#dc3030',
		fontWeight: '700',
	},
	text: {
		color: theme.text1,
	},
	hint: {
		color: theme.text2,
		fontSize: 12,
	},
	syncButton: {
		marginLeft: 12,
		paddingVertical: 6,
		paddingHorizontal: 12,
		backgroundColor: theme.importantColor1,
		borderRadius: 16,
	},
	syncButtonDisabled: {
		opacity: 0.6,
	},
	syncButtonText: {
		color: theme.labelText1,
		fontWeight: '600',
	},
	modalOverlay: {
		flex: 1,
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		justifyContent: 'center',
		alignItems: 'center',
		padding: 16,
	},
	modalContent: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 16,
		width: '100%',
		maxHeight: '80%',
	},
	modalTitle: {
		fontSize: 18,
		fontWeight: '600',
		marginBottom: 12,
		color: theme.text1,
	},
	warningText: {
		color: theme.danger1 || theme.semantic?.simple?.red || '#dc3030',
		marginBottom: 8,
	},
	modalList: {
		marginBottom: 16,
	},
	modalItem: {
		paddingVertical: 8,
		borderBottomWidth: 1,
		borderBottomColor: theme.border2 || theme.mainBg5,
	},
	modalItemTitle: {
		color: theme.text1,
		fontWeight: '600',
	},
	modalItemMeta: {
		color: theme.text2,
		marginTop: 2,
	},
	modalItemError: {
		color: theme.danger1 || theme.semantic?.simple?.red || '#dc3030',
		marginTop: 2,
	},
	modalItemTimestamp: {
		color: theme.text3,
		marginTop: 2,
		fontSize: 12,
	},
	modalCloseButton: {
		alignSelf: 'flex-end',
		paddingVertical: 6,
		paddingHorizontal: 12,
		backgroundColor: theme.mainBg3,
		borderRadius: 12,
		marginLeft: 12,
	},
	modalCloseText: {
		color: theme.text1,
		fontWeight: '600',
	},
	modalButtonRow: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	modalClearButton: {
		paddingVertical: 6,
		paddingHorizontal: 12,
		backgroundColor: theme.mainBg3,
		borderRadius: 12,
		borderWidth: 1,
		borderColor: theme.danger1 || theme.semantic?.simple?.red || '#dc3030',
		marginRight: 8,
	},
	modalClearButtonText: {
		color: theme.danger1 || theme.semantic?.simple?.red || '#dc3030',
		fontWeight: '600',
	},
	modalClearAllButton: {
		paddingVertical: 6,
		paddingHorizontal: 12,
		backgroundColor: theme.mainBg3,
		borderRadius: 12,
		borderWidth: 1,
		borderColor: theme.border2 || theme.mainBg5,
		marginRight: 8,
	},
	modalClearAllButtonText: {
		color: theme.text1,
		fontWeight: '600',
	},
	modalSyncButton: {
		paddingVertical: 6,
		paddingHorizontal: 12,
		backgroundColor: theme.importantColor1,
		borderRadius: 12,
	},
	modalSyncButtonText: {
		color: theme.labelText1,
		fontWeight: '600',
	},
});
